import React from 'react';
import { Link } from '@inertiajs/react';

interface ButtonProps {
    text: string;
    href?: string;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    id?: string;
    icon?: React.ReactNode;
    rightIcon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
    text,
    href,
    type = 'button',
    className = '',
    onClick,
    disabled = false,
    id,
    icon,
    rightIcon,
}) => {
    const buttonContent = (
        <>
            {icon}
            <span>{text}</span>
            {rightIcon}
        </>
    );

    if (href) {
        return (
            <Link
                href={href}
                className={`btn ${className} ${disabled ? 'is-disabled' : ''}`}
                id={id}
            >
                {buttonContent}
            </Link>
        );
    }

    return (
        <button
            type={type}
            className={`btn ${className}`}
            onClick={onClick}
            disabled={disabled}
            id={id}
        >
            {buttonContent}
        </button>
    );
};

export default Button;
